// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ajPXd{display:flex;align-items:center;flex-wrap:wrap}.kITF_{width:160px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ajPXd`,
	"datePicker": `kITF_`
};
export default ___CSS_LOADER_EXPORT___;
